import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../../store/actions/AuthActions';

// Shown instead of the whole console for team-member accounts — they only
// ever broadcast from the mobile app, so the web console has nothing for them.
const MobileOnlyNotice = ({ name }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-ink-950 tw-px-6">
      <div className="tw-w-full tw-max-w-md tw-rounded-2xl tw-border tw-border-line tw-bg-ink-900 tw-p-8 tw-text-center tw-shadow-pop">
        <div className="tw-mx-auto tw-mb-4 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-brand-soft tw-text-2xl tw-text-brand">
          <i className="fa-solid fa-mobile-screen-button" />
        </div>
        <h1 className="tw-text-lg tw-font-bold tw-text-heading">
          {name ? `Hi ${name}, ` : ''}broadcast from the Teve app
        </h1>
        <p className="tw-mt-2 tw-text-sm tw-text-content-muted">
          Team member accounts are for the mobile app only — there's nothing to do here on the web.
          Sign in on your phone with the same email and password to start streaming.
        </p>
        <div className="tw-mt-6 tw-flex tw-justify-center tw-gap-3">
          <a
            href="https://apps.apple.com/"
            target="_blank" rel="noreferrer"
            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-[10px] tw-border tw-border-line tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-content hover:tw-bg-ink-800"
          >
            <i className="fa-brands fa-apple" /> App Store
          </a>
          <a
            href="https://play.google.com/"
            target="_blank" rel="noreferrer"
            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-[10px] tw-border tw-border-line tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-content hover:tw-bg-ink-800"
          >
            <i className="fa-brands fa-google-play" /> Google Play
          </a>
        </div>
        <button
          className="tw-mt-6 tw-text-xs tw-font-semibold tw-text-content-faint hover:tw-text-content"
          onClick={() => dispatch(logoutUser(navigate))}
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default MobileOnlyNotice;
